const black = new URL("blackText.png", import.meta.url).href;
const small = new URL("smallNoText.png", import.meta.url).href;
const white = new URL("whiteText.png", import.meta.url).href;

export { black, small, white };
